import React from "react";
import { epochToNormalDate } from "../../../utils/utility";

const SingleTableRowDropdown = ({ record }) => {
  return (
    <table class="table">
      <thead>
        <tr>
          <th class="table-header">Дата/час</th>
          <th class="table-header">Оператор</th>
          <th class="table-header">Бюро</th>
          <th class="table-header">Тип</th>
        </tr>
      </thead>
      <tbody>
        {record.ticketNumber ? (
          <>
            <tr>
              <td class="table-cell">
                {epochToNormalDate(record.oprReservedDateTime)}
              </td>
              <td class="table-cell">{record.userReservedName}</td>
              <td class="table-cell">{record.cashdeskReservedName}</td>
              <td class="table-cell highlight">Резервация</td>
            </tr>
            <tr>
              <td class="table-cell">
                {epochToNormalDate(record.oprSalelDateTime)}
              </td>

              <td class="table-cell">{record.userSalelName}</td>
              <td class="table-cell">{record.cashdeskSaleName}</td>
              <td class="table-cell highlight">Продажба</td>
            </tr>
          </>
        ) : (
          <tr>
            <td class="table-cell">
              {epochToNormalDate(record.oprReservedDateTime)}
            </td>
            <td class="table-cell">{record.userReservedName}</td>
            <td class="table-cell">{record.cashdeskReservedName}</td>
            <td class="table-cell highlight">Резервация</td>
          </tr>
        )}

        {record.isAnnulSale && (
          <tr>
            <td class="table-cell">
              {epochToNormalDate(record.oprAnnulSaleDateTime)}
            </td>
            <td class="table-cell">{record.userAnnulSaleName}</td>
            <td class="table-cell">{record.cashdeskAnnulSaleName}</td>
            <td class="table-cell highlight">Сторниране на Продажба</td>
          </tr>
        )}

        {record.isAnnulReserved && (
          <tr>
            <td class="table-cell">
              {epochToNormalDate(record.oprAnnulReservedDateTime)}
            </td>
            <td class="table-cell">{record.cashdeskReservedName}</td>
            <td class="table-cell">{record.userAnnulReservedName}</td>
            <td class="table-cell highlight">Анулирана резервация</td>
          </tr>
        )}
      </tbody>
    </table>
  );
};

export default SingleTableRowDropdown;
